/** How the items table lays out what opens under a row (the tree's groups, a folder's contents). */

/** A cell across the whole table, whatever its columns. */
export const SPAN = 1000;
/** Items a group (or folder) shows at first, and again on "Show more". */
export const STEP = 50;
/** Indentation per level (rem). */
export const INDENT = 1.5;
